var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@/styles/Characters/CharactersPage.less';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useApiInstance } from '@/api';
import CharacterDetailsSidebar from '@/components/Common/CharacterDetailsSidebar';
import InitiativeCard from '@/components/InitiativeTracker/InitiativeCard';
import { useApiContext } from '@/context/ApiContext';
import { useAuth } from '@/context/AuthContext';
const CharactersPage = () => {
    const { user, loading: isAuthLoading } = useAuth();
    const navigate = useNavigate();
    const { useMockApi } = useApiContext();
    const [characters, setCharacters] = useState([]);
    const [selectedChar, setSelectedChar] = useState(null);
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const { t } = useTranslation();
    const api = useApiInstance();
    useEffect(() => {
        if (isAuthLoading)
            return;
        if (user === null) {
            navigate('/auth');
            return;
        }
        if (useMockApi) {
            // Если используется mock API, перенаправляем на страницу инициативного трекера
            console.log('Using mock API, redirecting to initiative tracker');
            navigate('/initiative-tracker', { replace: true });
            return;
        }
        api.characterApiInstance.list({ created_by_me: true, page_size: 100 }).then(setCharacters);
    }, [user, isAuthLoading, useMockApi, navigate, api.characterApiInstance]);
    // Открывать сайдбар редактирования при глобальном событии от карточки
    useEffect(() => {
        const handler = (event) => {
            if (event instanceof CustomEvent && event.detail) {
                console.log('[CharactersPage] openCharacterDetails event received', event.detail);
                openSidebar(event.detail);
            }
        };
        document.addEventListener('openCharacterDetails', handler);
        return () => document.removeEventListener('openCharacterDetails', handler);
    }, []);
    const openSidebar = (char) => {
        document.body.style.overflow = 'hidden';
        setSelectedChar(char);
        setIsEdit(true);
        setSidebarOpen(true);
    };
    const closeSidebar = () => {
        setSidebarOpen(false);
        setSelectedChar(null);
        setIsEdit(false);
        document.body.style.overflow = 'auto';
    };
    const handleCreate = () => {
        setIsEdit(false);
        setSidebarOpen(true);
    };
    const handleAdd = (character) => __awaiter(void 0, void 0, void 0, function* () {
        const created = yield api.characterApiInstance.create(character);
        created.initiative = character.initiative ? character.initiative : 0;
        setCharacters((chars) => [...chars, created]);
        closeSidebar();
    });
    const handleSave = (character) => __awaiter(void 0, void 0, void 0, function* () {
        console.log('Saving character:', character);
        const updated = yield api.characterApiInstance.update(character);
        console.log('Updated character:', updated);
        setCharacters((chars) => chars.map((c) => (c.id === updated.id ? updated : c)));
        closeSidebar();
    });
    const handleDelete = (character) => __awaiter(void 0, void 0, void 0, function* () {
        yield api.characterApiInstance.delete(character.id);
        setCharacters((chars) => chars.filter((c) => c.id !== character.id));
        closeSidebar();
    });
    const previewElement = selectedChar ? (_jsx(InitiativeCard, { card: selectedChar, onSelect: () => { }, isSelected: true, showInitiative: false, className: "character-selected-stats-sidebar" })) : null;
    return (_jsxs("div", { className: "characters-page", children: [_jsxs("div", { className: "characters-list", children: [_jsx("h2", { children: t('myCharacters.charactersList') }), _jsx("button", { onClick: handleCreate, children: t('myCharacters.addCharacter') }), _jsx("ul", { children: characters.map((char) => (_jsx("li", { className: "character-card", onClick: () => openSidebar(char), onKeyDown: () => openSidebar(char), children: _jsx(InitiativeCard, { card: char, onSelect: () => openSidebar(char), isSelected: (selectedChar === null || selectedChar === void 0 ? void 0 : selectedChar.id) === char.id, showInitiative: false }) }, char.id))) })] }), _jsx("div", { className: "pagination" }), _jsx(CharacterDetailsSidebar, { character: selectedChar, isOpen: isSidebarOpen, onClose: closeSidebar, onAdd: handleAdd, onSave: handleSave, onDelete: handleDelete, previewElement: previewElement })] }));
};
export default CharactersPage;
